<template>
  <div style="min-height: 92vh">
    <v-row>
      <v-col md="8">
        <h3>Nombres de tarifas</h3>
      </v-col>
      <v-col md="4">
        <ModuleHeader>Departamento</ModuleHeader>
        <selectDepartment></selectDepartment>
      </v-col>
    </v-row>

    <uv-data-table :config="config" :data="horarios" :pageRows="15" @buttonClick="dtButtonClick"
      @buttonOptClick="optButtonClick"></uv-data-table>
    <modal v-model="showModal" :showFooter="false" title="Nombres de tarifas">
      <subcategoriaForm :edit="editMode" :key="formIndex" @toggle="toggleModal" :dataEdit="editData"
        @successData="successData">
      </subcategoriaForm>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import subcategoriaForm from "./SubCategoriaForm.vue";

export default {
  name: "SubcategoriaCrud",
  components: {
    modal,
    uvDataTable,
    subcategoriaForm,
  },
  props: [],
  data() {
    return {
      self: this,
      showModal: false,
      formKey: 0,
      formIndex: 0,
      editMode: false,
      MainDepartamento: "",
      horarios: [],
      editData: {},
      config: {
        selectableRow: true,
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "agregarHorarios",
            require: false,
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editHorarios",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteHorarios",
            require: true,
          },
        ],
        fields: [
          {
            title: "Nombre",
            text: "Nombre",
            value: "Nombre",
            dataName: "Nombre",
          },
        ],
      },
    };
  },
  methods: {
    async getCategorias() {
      this.horarios = [];
      /* obtiene el listado de temporadas activas en el sistema  */
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Tarifas/" + this.MainDepartamento + "/SubCategorias"
        );

      if (!data.exists()) {
        return false;
      }

      let arrayTarifas = Object.entries(data.val());
      arrayTarifas.forEach((element) => {
        this.horarios.push({ id: element[0], ...element[1] });
      });
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "agregarHorarios") {
        this.formIndex++;
        this.editMode = false;
        this.editData = {};

        this.toggleModal(true);
      }
      if (buttonId == "editHorarios") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.horarios,
          "id",
          idSelected[0]
        );
        this.showModal = true;
      }
      if (buttonId == "deleteHorarios") {
        this.deleteSubcategoria(idSelected[0]);
      }
    },
    optButtonClick() { },
    deleteSubcategoria(id) {
      let datos = { Id: id, Departamento: this.MainDepartamento };
      this.$swal({
        title: "¿Deseas eliminar el nombre de tarifa?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifas-eliminarSubCategoria", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "El nombre de tarifa se elimino correctamente",
              "El nombre de tarifa se elimino correctamente",
              "success"
            );
            this.getCategorias();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    successData(data) {
      let sendData = {
        Nombre: data.Nombre,
      };

      sendData.Departamento = this.MainDepartamento;
      this.$pgsHelper.log(sendData);

      if (data.Id == "") {
        this.createSubcategoria(sendData);
      } else {
        sendData.Id = data.Id;
        this.editSubcategoria(sendData);
      }

      //this.editProduct(data);
    },
    createSubcategoria(datos) {
      this.$swal({
        title: "¿Deseas agregar este nuevo nombre de tarifa?",
        text: "Podras editarlo cuando quieras",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Agregar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifas-crearSubCategoria", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          // this.$emit('reloadClient');
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El nombre de tarifa se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getCategorias();
            });
          } else {
            this.$swal(
              "Error guardando Datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editSubcategoria(datos) {
      this.$swal({
        title: "¿Deseas editar el nombre de tarifa?",
        text: "Las categorías creadas se ajustaran a los cambios editados ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Editar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Tarifas-editarSubCategoria", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El nombre de tarifa se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
              this.getCategorias();
            });
          } else {
            this.$swal(
              "Error guardando información",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },

    toggleModal(open) {
      this.showModal = open;
    },
  },
  computed: {},
  watch: {},
  mounted() { },
  created() {
    this.MainDepartamento = localStorage.getItem("selectedDepartment");
    this.getCategorias();

    //this.getOrigenes();
    //this.getProducts();
  },
};
</script>
